import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=57059912&scoped=true&"
import script from "./TitleInfo.vue?vue&type=script&lang=js&"
export * from "./TitleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57059912",
  null
  
)

export default component.exports